/**
 * distinct
 *
 * uso: const unique = array.filter(distinct);
 */
export default (value, index, self) => {
  return self.indexOf(value) === index;
};
